<template>
  <v-dialog v-model="openMode" max-width="750px" content-class="upload-dialog-wrapper" persistent>
    <v-card class="upload-card">
      <!-- Header -->
      <v-card-title class="upload-header">
        <div class="header-content">
          <div class="header-icon-title">
            <v-avatar size="40" color="#0d2c6d" class="ml-3">
              <v-icon color="white">mdi-cloud-upload</v-icon>
            </v-avatar>
            <div>
              <h2 class="header-title">העלאת הקלטות</h2>
              <p class="header-subtitle">העלה קבצי שמע ווידאו למערכת</p>
            </div>
          </div>
          <v-btn icon @click="openMode = false" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Content -->
      <v-card-text class="upload-content">
        <!-- Options Section -->
        <div class="options-section">
          <h3 class="section-title">
            <v-icon small color="#0d2c6d" class="ml-2">mdi-cog</v-icon>
            אפשרויות העלאה
          </h3>

          <div class="options-grid">
            <v-card class="option-card" :class="{ 'option-active': sendCalls }" @click="sendCalls = !sendCalls">
              <v-card-text class="option-content">
                <div class="option-header">
                  <v-checkbox v-model="sendCalls" hide-details color="#0d2c6d" class="option-checkbox"
                    @click.stop></v-checkbox>
                  <v-icon color="#0d2c6d" class="option-icon">mdi-phone-outgoing</v-icon>
                </div>
                <div class="option-text">
                  <div class="option-title">שלח צינתוק</div>
                  <div class="option-description">שלח הודעה לאחר סיום העלאה</div>
                </div>
              </v-card-text>
            </v-card>

            <v-card class="option-card" :class="{ 'option-active': allowMultiple }"
              @click="allowMultiple = !allowMultiple">
              <v-card-text class="option-content">
                <div class="option-header">
                  <v-checkbox v-model="allowMultiple" hide-details color="#0d2c6d" class="option-checkbox"
                    @click.stop></v-checkbox>
                  <v-icon color="#0d2c6d" class="option-icon">mdi-file-multiple</v-icon>
                </div>
                <div class="option-text">
                  <div class="option-title">העלאה מרובה</div>
                  <div class="option-description">אפשר העלאת מספר קבצים בו זמנית</div>
                </div>
              </v-card-text>
            </v-card>

            <!-- הוספת כרטיס תזמון פרסום -->
            <v-card class="option-card" :class="{ 'option-active': scheduleUpload }"
              @click="scheduleUpload = !scheduleUpload">
              <v-card-text class="option-content">
                <div class="option-header">
                  <v-checkbox v-model="scheduleUpload" hide-details color="#0d2c6d" class="option-checkbox"
                    @click.stop></v-checkbox>
                  <v-icon color="#0d2c6d" class="option-icon">mdi-calendar-clock</v-icon>
                </div>
                <div class="option-text">
                  <div class="option-title">תזמון פרסום</div>
                  <div class="option-description">קבע מועד לפרסום ההקלטה</div>
                </div>
              </v-card-text>
            </v-card>

            <!-- הוספת כרטיס הגבלת זמן השמעה -->
            <v-card class="option-card" :class="{ 'option-active': listenTimeLimit }"
              @click="listenTimeLimit = !listenTimeLimit">
              <v-card-text class="option-content">
                <div class="option-header">
                  <v-checkbox v-model="listenTimeLimit" hide-details color="#0d2c6d" class="option-checkbox"
                    @click.stop></v-checkbox>
                  <v-icon color="#0d2c6d" class="option-icon">mdi-timer-off</v-icon>
                </div>
                <div class="option-text">
                  <div class="option-title">הגבלת זמן השמעה</div>
                  <div class="option-description">קבע מועד סיום להאזנה</div>
                </div>
              </v-card-text>
            </v-card>
          </div>

          <!-- הוספת בורר תאריך לתזמון פרסום -->
          <v-expand-transition>
            <div v-if="scheduleUpload" class="date-picker-section">
              <div class="date-picker-card">
                <v-icon color="#0d2c6d" class="ml-2">mdi-calendar-clock</v-icon>
                <span class="date-picker-label">תאריך ושעה פרסום:</span>
                <div class="date-time-inputs">
                  <v-text-field v-model="scheduleDate" type="date" outlined dense hide-details class="date-input"
                    :min="minDate" :max="maxDateSchedule"></v-text-field>
                  <v-text-field v-model="scheduleTime" type="time" outlined dense hide-details
                    class="time-input"></v-text-field>
                </div>
              </div>
            </div>
          </v-expand-transition>

          <!-- הוספת בורר תאריך להגבלת זמן השמעה -->
          <v-expand-transition>
            <div v-if="listenTimeLimit" class="date-picker-section">
              <div class="date-picker-card">
                <v-icon color="#0d2c6d" class="ml-2">mdi-timer-off</v-icon>
                <span class="date-picker-label">תאריך ושעה סיום האזנה:</span>
                <div class="date-time-inputs">
                  <v-text-field v-model="timeLimitDate" type="date" outlined dense hide-details class="date-input"
                    :min="minDate" :max="maxDateLimitTime"></v-text-field>
                  <v-text-field v-model="timeLimitTime" type="time" outlined dense hide-details
                    class="time-input"></v-text-field>
                </div>
              </div>
            </div>
          </v-expand-transition>
        </div>

        <!-- Upload Section -->
        <div class="upload-section">
          <h3 class="section-title">
            <v-icon small color="#0d2c6d" class="ml-2">mdi-file-upload</v-icon>
            בחירת קבצים
          </h3>

          <div class="upload-area">
            <file-pond ref="pond" name="record" class="file-upload" allow-multiple="true" allow-reorder="true"
              accepted-file-types="audio/*,video/mp4" max-file-size="100MB" :instantUpload="false"
              :maxParallelUploads="allowMultiple ? 5 : 1" :allowRevert="false" :credits="false"
              @updatefiles="handleFileOrder" @processfile="handleUploadComplete" :server="serverOptions" :label-idle="`<div class='upload-placeholder'>
                <div class='upload-icon'>📁</div>
                <div class='upload-text'>גרור ושחרר קבצים לכאן</div>
                <div class='upload-subtext'>או <span class='upload-link'>בחר קבצים</span> מהמחשב</div>
                <div class='upload-formats'>תומך בקבצי שמע ווידאו (עד 100MB)</div>
              </div>`" :label-invalid-field="'השדה מכיל ערכים לא חוקיים'" :label-file-processing="'מעלה...'"
              :label-file-processing-complete="'הקובץ הועלה בהצלחה!'" :label-file-remove="'הסר'"
              :label-tap-to-retry="'הקש כדי לנסות שוב'" />
          </div>

          <!-- Files Summary -->
          <div v-if="files.length > 0" class="files-summary">
            <div class="summary-header">
              <v-icon small color="#0d2c6d" class="ml-2">mdi-file-check</v-icon>
              <span class="summary-title">קבצים נבחרו: {{ files.length }}</span>
            </div>
            <div class="summary-details">
              <v-chip v-for="(file, index) in files.slice(0, 3)" :key="index" small outlined color="#0d2c6d"
                class="ml-2 mb-1">
                {{ file.name }}
              </v-chip>
              <v-chip v-if="files.length > 3" small color="#0d2c6d" text-color="white" class="ml-2 mb-1">
                +{{ files.length - 3 }} נוספים
              </v-chip>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Actions -->
      <v-card-actions class="upload-actions">
        <div class="actions-content">
          <div class="upload-info" v-if="files.length > 0">
            <v-icon small color="success" class="ml-1">mdi-information</v-icon>
            <span class="info-text">{{ files.length }} קבצים מוכנים להעלאה</span>
          </div>
          <v-spacer></v-spacer>
          <div class="action-buttons">
            <v-btn text class="cancel-btn" @click="openMode = false">
              ביטול
            </v-btn>
            <v-btn color="#0d2c6d" class="upload-btn" :disabled="files.length === 0" :loading="isUploading"
              @click="submitAllFiles" elevation="2">
              <v-icon left>mdi-cloud-upload</v-icon>
              העלה {{ files.length > 0 ? `${files.length} קבצים` : 'קבצים' }}
            </v-btn>
          </div>
        </div>
      </v-card-actions>
    </v-card>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-dialog>
</template>

<script>
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import SnackBar from '@/components/widgets/snackBar.vue';

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  props: {
    value: { type: Boolean, default: false },
  },
  components: {
    SnackBar,
    FilePond
  },
  data() {
    return {
      serverOptions: {
        process: {
          url: `${process.env.VUE_APP_BASE_URL}/records/add_record`,
          method: 'POST',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          ondata: (formData) => {
            this.filesStartUploadedCount++;
            if (this.filesStartUploadedCount === this.files.length) {
              formData.append('sendCalls', this.sendCalls);
              formData.append('scheduleUpload', this.scheduleUpload);
              if (this.scheduleUpload && this.scheduleDate) {
                formData.append('scheduleDate', this.getFullDateTime(this.scheduleDate, this.scheduleTime));
              }
              formData.append('listenTimeLimit', this.listenTimeLimit);
              if (this.listenTimeLimit && this.timeLimitDate) {
                formData.append('timeLimitDate', this.getFullDateTime(this.timeLimitDate, this.timeLimitTime));
              }
            }
            return formData;
          }
        }
      },
      sendCalls: false,
      snackbar: false,
      allowMultiple: false,
      snackbarColorBt: "green",
      snacbarText: "",
      files: [],
      filesStartUploadedCount: 0,
      filesEndtUploadedCount: 0,
      isUploading: false,
      scheduleUpload: false,
      scheduleDate: '',
      scheduleTime: '',
      listenTimeLimit: false,
      timeLimitDate: '',
      timeLimitTime: ''
    };
  },
  methods: {
    getFullDateTime(date, time) {
      if (!date) return '';
      const timeStr = time || '00:00';
      return `${date}T${timeStr}:00`;
    },

    handleFileOrder(files) {
      this.files = files.map(fileItem => fileItem.file);
    },

    async submitAllFiles() {
      if (this.files.length === 0) {
        this.showSnackBar('לא נבחרו קבצים', 'red');
        return;
      }

      if (this.scheduleUpload && !this.scheduleDate) {
        this.showSnackBar('יש לבחור תאריך לתזמון הפרסום', 'red');
        return;
      }

      if (this.listenTimeLimit && !this.timeLimitDate) {
        this.showSnackBar('יש לבחור תאריך להגבלת זמן ההשמעה', 'red');
        return;
      }

      this.isUploading = true;
      this.filesStartUploadedCount = 0;
      this.filesEndtUploadedCount = 0;

      try {
        await this.$refs.pond.processFiles();
        this.showSnackBar('הקבצים הועלו בהצלחה', 'green');
      } catch (error) {
        this.showSnackBar('שגיאה בהעלאה', 'red');
      } finally {
        this.isUploading = false;
      }
    },

    handleUploadComplete() {
      this.filesEndtUploadedCount++;

      if (this.filesEndtUploadedCount === this.files.length) {
        this.showSnackBar('הפעולה הסתיימה בהצלחה!', 'green');
        this.$emit('uploadComplete');
        this.isUploading = false;
      }
    },

    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    }
  },
  computed: {
    openMode: {
      get() {
        return this.value;
      },
      set(v) {
        return this.$emit('input', v);
      }
    },
    minDate() {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return date.toISOString().split('T')[0];
    },
    maxDateLimitTime() {
      const date = new Date();
      date.setDate(date.getDate() + 30);
      return date.toISOString().split('T')[0];
    },
    maxDateSchedule() {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      return date.toISOString().split('T')[0];
    }
  },
}
</script>

<style scoped>
.upload-dialog-wrapper {
  border-radius: 16px;
  overflow: hidden;
}

.upload-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.upload-header {
  padding: 24px;
  background: linear-gradient(135deg, #f8f9fd 0%, #e8f0fe 100%);
  border-bottom: 1px solid rgba(13, 44, 109, 0.1);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.header-icon-title {
  display: flex;
  align-items: center;
}

.header-title {
  color: #0d2c6d;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.header-subtitle {
  color: rgba(13, 44, 109, 0.7);
  font-size: 0.875rem;
  margin: 4px 0 0 0;
}

.close-btn {
  color: rgba(13, 44, 109, 0.6);
}

.close-btn:hover {
  background-color: rgba(13, 44, 109, 0.1);
}

.upload-content {
  padding: 24px;
}

.section-title {
  color: #0d2c6d;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.options-section {
  margin-bottom: 32px;
}

.options-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.option-card {
  border: 2px solid rgba(13, 44, 109, 0.1);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fafbfc;
}

.option-card:hover {
  border-color: rgba(13, 44, 109, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(13, 44, 109, 0.1);
}

.option-active {
  border-color: #0d2c6d !important;
  background: rgba(13, 44, 109, 0.05) !important;
}

.option-content {
  padding: 16px !important;
}

.option-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.option-checkbox {
  margin: 0 !important;
}

.option-icon {
  font-size: 24px;
}

.option-text {
  text-align: right;
}

.option-title {
  font-weight: 600;
  color: #333;
  font-size: 0.95rem;
  margin-bottom: 4px;
}

.option-description {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.8rem;
  line-height: 1.3;
}

/* סגנונות לבורר תאריך ושעה */
.date-picker-section {
  margin-top: 16px;
}

.date-picker-card {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px;
  background: rgba(13, 44, 109, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(13, 44, 109, 0.15);
}

.date-picker-label {
  font-weight: 600;
  color: #0d2c6d;
  font-size: 0.95rem;
}

.date-time-inputs {
  display: flex;
  gap: 12px;
  flex: 1;
  min-width: 250px;
}

.date-input {
  flex: 1.5;
  max-width: 180px;
}

.time-input {
  flex: 1;
  max-width: 120px;
}

.upload-section {
  margin-bottom: 16px;
}

.upload-area {
  border-radius: 12px;
  overflow: hidden;
}

.file-upload {
  border: 2px dashed rgba(13, 44, 109, 0.3);
  border-radius: 12px;
  background: #fafbfc;
  transition: all 0.3s ease;
}

.file-upload:hover {
  border-color: #0d2c6d;
  background: rgba(13, 44, 109, 0.02);
}

.files-summary {
  margin-top: 16px;
  padding: 16px;
  background: rgba(13, 44, 109, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(13, 44, 109, 0.1);
}

.summary-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.summary-title {
  font-weight: 600;
  color: #0d2c6d;
}

.summary-details {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.upload-actions {
  padding: 20px 24px;
  background: #fafbfc;
}

.actions-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.upload-info {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
}

.info-text {
  font-weight: 500;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.cancel-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0;
  color: rgba(0, 0, 0, 0.6);
}

.upload-btn {
  background: linear-gradient(135deg, #0d2c6d, #1a3a8a) !important;
  color: white !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  padding: 0 24px;
  height: 40px;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.upload-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(13, 44, 109, 0.3) !important;
}

.upload-btn:disabled {
  background: rgba(0, 0, 0, 0.12) !important;
  color: rgba(0, 0, 0, 0.38) !important;
}

/* FilePond Custom Styles */
:deep(.filepond--panel-root) {
  background: transparent;
  border: none;
}

:deep(.filepond--drop-label) {
  color: #0d2c6d;
  font-size: 16px;
  cursor: pointer;
}

:deep(.upload-placeholder) {
  text-align: center;
  padding: 32px 16px;
}

:deep(.upload-icon) {
  font-size: 48px;
  margin-bottom: 16px;
}

:deep(.upload-text) {
  font-size: 18px;
  font-weight: 600;
  color: #0d2c6d;
  margin-bottom: 8px;
}

:deep(.upload-subtext) {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 12px;
}

:deep(.upload-link) {
  color: #ffb91a;
  font-weight: 600;
  text-decoration: underline;
}

:deep(.upload-formats) {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}

:deep(.filepond--file) {
  background: rgba(13, 44, 109, 0.05);
  border-radius: 8px;
}

:deep(.filepond--file-action-button) {
  background: rgba(13, 44, 109, 0.8);
}

/* Responsive */
@media (max-width: 600px) {
  .options-grid {
    grid-template-columns: 1fr;
  }

  .date-picker-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .date-time-inputs {
    width: 100%;
  }

  .date-input,
  .time-input {
    max-width: none;
  }

  .actions-content {
    flex-direction: column;
    gap: 12px;
  }

  .action-buttons {
    width: 100%;
    justify-content: stretch;
  }

  .cancel-btn,
  .upload-btn {
    flex: 1;
  }
}
</style>
